import { CryptoAsset } from '../../types/crypto';

export const fetchXrpData = async (address: string) => {
  const rpcUrl = 'https://xrplcluster.com/';
  
  try {
    // Fetch Native XRP balance
    const accountInfoRes = await fetch(rpcUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        method: "account_info",
        params: [{
          account: address,
          ledger_index: "validated"
        }]
      })
    });
    
    const accountInfo = await accountInfoRes.json();
    
    if (accountInfo.result.error) {
       throw new Error(accountInfo.result.error_message || 'Error fetching XRP account info');
    }
    
    const drops = accountInfo.result.account_data.Balance;
    const nativeBalance = parseFloat(drops) / 1e6;

    let nativePriceUsd = 0;
    const bRes = await fetch('https://api.binance.com/api/v3/ticker/price?symbol=XRPUSDT');
    if (!bRes.ok) throw new Error('XRP price fetch failed');
    const bData = await bRes.json();
    nativePriceUsd = parseFloat(bData.price);

    // Fetch Trustlines (Tokens)
    const linesRes = await fetch(rpcUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        method: "account_lines",
        params: [{
          account: address
        }]
      })
    });
    
    const lines = await linesRes.json();

    const assets: CryptoAsset[] = [];
    
    if (lines.result.lines) {
      lines.result.lines.forEach((line: any) => {
        const balance = parseFloat(line.balance);
        // Note: account_lines returns negative balances if the other party owes the account, 
        // but typically tokens have positive balance. Using Math.abs() to be safe or just checking > 0.
        if (balance > 0) {
          assets.push({
            id: `${line.currency}-${line.account}`,
            name: line.currency,
            symbol: line.currency,
            balance,
            usdValue: 0, // Hard to get generic trustline prices without specific DEX API
            priceUsd: 0
          });
        }
      });
    }

    return {
      nativeBalance,
      nativeUsdValue: nativeBalance * nativePriceUsd,
      nativePriceUsd,
      assets
    };
  } catch (error) {
    console.error('Error fetching XRP data:', error);
    throw error;
  }
};
